<template>
  <div class="main">
    <el-container>
      <el-header>
        <div class="main-header">
          <img class="headerLogo" src="../assets/logoYellow.png" />
          <div class="header-avator-con">
            <div class="user-dropdown-menu-con">
              <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                <Dropdown transfer  trigger="hover" @on-click="handleClickUserDropdown" v-if="userInfo">
                  <Button class="jihuo" shape="circle" @click='activateModal=true'>激活</Button>
                  <a style="color: #fff">
                    <Avatar v-if="userInfo.avatar" :src="userInfo.avatar" style="background: #619fe7;margin-left: .10px;"></Avatar>
                    <span style="color:#666" class="main-user-name" v-if="userInfo.nickName || userInfo.username">{{ userInfo.nickName ? userInfo.nickName : userInfo.username }}</span>
                    <Icon type="md-arrow-dropdown" />
                  </a>
                  <DropdownMenu slot="list">
                    <!-- <DropdownItem name="changePass">
                      {{ '修改密码' }}
                    </DropdownItem> -->
                    <DropdownItem name="loginout" divided>
                      {{ '退出' }}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <div v-else>
                  <!-- v-if="userInfo.id" -->
                  <a href="javascript:;" @click="loginModal = true">登录</a>
                  <a href="javascript:;" style="margin:0 20px" @click="toRegitst">注册</a>
                  <a href="javascript:;" @click="toActivate">激活</a>
                </div>
                
              </Row>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="240px">
          <div v-if="userInfo.id" class="info">
            <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
            <span v-if="userInfo.username">{{userInfo.username}}</span>
          </div>
          <Menu mode="vertical" :theme="theme1" active-name="1" @on-select="selectMenu">
            <!-- <MenuItem name="index">
              <Icon type="ios-home" />
              首页
            </MenuItem> -->
            <MenuItem name="knowledgeStrong">
              <Icon type="md-planet" />
              知识点强化
            </MenuItem>
            <MenuItem name="questionBank">
              <Icon type="ios-albums" />
              题库练习
            </MenuItem>
            <!-- <Submenu name="3">
                <template slot="title">
                    <Icon type="ios-stats" />
                    题库练习
                </template>
                <MenuGroup title="使用">
                    <MenuItem name="3-1">新增和启动</MenuItem>
                    <MenuItem name="3-2">活跃分析</MenuItem>
                    <MenuItem name="3-3">时段分析</MenuItem>
                </MenuGroup>
                <MenuGroup title="留存">
                    <MenuItem name="3-4">用户留存</MenuItem>
                    <MenuItem name="3-5">流失用户</MenuItem>
                </MenuGroup>
            </Submenu> -->
            <MenuItem name="simulationTest">
              <Icon type="ios-compass" />
              模拟测验
            </MenuItem>
            <MenuItem name="errorCollection">
              <Icon type="ios-open" />
              我的错题集
            </MenuItem>
            <MenuItem name="myExam">
              <Icon type="ios-disc" />
              我的考试
            </MenuItem>
          </Menu>
        </el-aside>
        <el-main>
          <Breadcrumb separator=">">
            <!-- <BreadcrumbItem to="/index">首页</BreadcrumbItem> -->
            <BreadcrumbItem v-if="name === 'knowledgeStrong' || name === 'practise'" to="/knowledgeStrong" >知识点强化</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'questionBank'" to="/questionBank">题库列表</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'simulationTest'" to="/simulationTest">模拟测验</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'errorCollection'" to="/errorCollection">我的错题集</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'simulationTestDetail'" to="/simulationTest">模拟测验</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'simulationTestDetail'" to="/simulationTestDetail">模拟测验详情</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'testStore'" to="/questionBank">题库列表</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'testStore'" to="/testStore">题库练习</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'knowledgeStrongPractise'" to="/knowledgeStrong">知识点强化</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'knowledgeStrongPractise'" to="/knowledgeStrongPractise">知识点强化练习</BreadcrumbItem>
            <BreadcrumbItem v-if="name === 'myExam'" to="/myExam">我的考试</BreadcrumbItem>
          </Breadcrumb>
          <div class="t-con" v-if="name === 'index'"><home></home></div>
          <div class="t-con" v-if="name === 'knowledgeStrong' || name === 'practise'"><knowledgeStrong :knowledgePointList="knowledgePointList" :loadingTable="loading" @childSearch="parentSearch"></knowledgeStrong></div>
          <div class="t-con" v-if="name === 'questionBank'"><questionBank :bankList="questionBank" :tkLoading='tkLoading'></questionBank></div>
          <div class="t-con" v-if="name === 'simulationTest'"><simulationTest :paperList="paperList" :tkLoading='tkLoading'></simulationTest></div>
          <div class="t-con" v-if="name === 'errorCollection'"><errorCollection ref="errorChild" :errorTopList="errorTopList"></errorCollection></div>
          <div class="t-con" v-if="name === 'simulationTestDetail'"><simulationTestDetail></simulationTestDetail></div>
          <div class="t-con" v-if="name === 'testStore'"><testStore></testStore></div>
          <div class="t-con" v-if="name === 'knowledgeStrongPractise'"><knowledgeStrongPractise></knowledgeStrongPractise></div>
          <div class="t-con" v-if="name === 'myExam'"><myExam :myExamList='myExamList' :tkLoading='tkLoading'></myExam></div>

        </el-main>
      </el-container>
    </el-container>
    <!-- 激活框 -->
    <Modal class="activate-modal" v-model="activateModal" @on-cancel="handleModalReset" :z-index="9999">
      <div class="tit">激活产品</div>
      <Form ref="formData" :model="form" :rules="formDataValidate">
        <FormItem prop="number">
          <Input v-model="form.number" size="large" placeholder="请输入激活码" clearable autocomplete="off" />
        </FormItem>
      </Form>
      <Button size="large" :loading="submitLoading" @click="handleModalSubmit">激活</Button>
    </Modal>
    <!-- 登录框 -->
    <Modal v-model="loginModal" class="login-modal" :z-index="9999">
      <Row class="login-form login" @keydown.enter.native="submitLogin">
        <Tabs v-model="tabName">
          <TabPane label="账户登录" name="username">
            <Form ref="loginForm" :model="loginForm" :rules="loginFormDataValidate" class="form" v-if="tabName == 'username'">
              <FormItem prop="username">
                <Input v-model="loginForm.username" size="large" clearable placeholder="请输入用户名" autocomplete="off" />
              </FormItem>
              <FormItem prop="password">
                <Input type="password" password v-model="loginForm.password" size="large"  placeholder="请输入密码" autocomplete="off" />
              </FormItem>
            </Form>
            <Row>
              <Button class="login-btn" type="primary" size="large" @click="submitLogin">
                <span v-if="!loading">登录</span>
                <span v-else>登录中...</span>
              </Button>
            </Row>
            <!-- <Row type="flex" justify="end">
              <a class="forget-pass cwhite" @click="handleDropDown">
                忘记密码
              </a>
            </Row> -->
          </TabPane>
        </Tabs>
      </Row>
      <div slot="footer"></div>
    </Modal>
    <!-- 注册框 -->
    <Modal v-model="registModal" class="regit-modal" :z-index="9999">
      <Regist @childFn="parentLoginFn"></Regist>
    </Modal>
  </div>
</template>
<script>
import xbzUtil from 'xbz-front-compilb/src/libs/util.js'

import home from '@/views/home/home.vue'
import knowledgeStrong from '@/views/practise/knowledgeStrong.vue'
import questionBank from '@/views/practise/questionBank.vue'
import simulationTest from '@/views/practise/simulationTest.vue'
import errorCollection from '@/views/practise/errorCollection.vue'
import simulationTestDetail from '@/views/practise/simulationTestDetail.vue'
import testStore from '@/views/practise/testStore.vue'
import knowledgeStrongPractise from '@/views/practise/knowledgeStrongPractise.vue'
import myExam from '@/views/practise/myExam.vue'
import util from '@/libs/util'
import Regist from './regist.vue'
export default {
  components: { home, knowledgeStrong, questionBank, simulationTest, errorCollection, simulationTestDetail, testStore, knowledgeStrongPractise, Regist, myExam },
  data() {
    const validateActivationCode = (rule, value, callback) => {
      if (!xbzUtil._handleCheckCardLuhn(value,9)) {
        callback(new Error('激活码格式错误'))
      } else {
        callback()
      }
    }
    return {
      registModal: false,
      registForm: {},
      registFormDataValidate: {},
      submitLoading: false,

      activateModal: false,
      theme1: 'light',
      userInfo: {},
      name: '',
      form: {},
      loading: false,
      formDataValidate: {
        number: [
          {
            validator: validateActivationCode,
            required: true,
            trigger: 'blur'
          }
        ],
      },
      knowledgePointList: [],
      questionBank: [],
      paperList: [],
      errorTopList: [],
      myExamList: [],
      loginModal: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormDataValidate: {},
      tabName: 'username',
      tkLoading: false
    }
  },
  computed: {
    
  },
  watch: {
    $route(curr, old) {
      this.name = curr.name
    },
    // name(curr, old) {
    //   switch (curr) {
    //     case 'index':
    //       console.log('indexclick')
    //       break
    //     case 'knowledgeStrong':
    //       this._getMyKnowledgePointList( {userId: this.userInfo.id} )
    //       break
    //     case 'questionBank':
    //       this._getMyQuestionBankList()
    //       break
    //     case 'simulationTest':
    //       this._getMyExamPaperList()
    //       break
    //     case 'errorCollection':
    //       this._getKnowledgePointErrorsTop10()
    //       // this.$refs.errorChild.init()
    //       break
    //     case 'myExam':
    //       this._getMyExamPaper()
    //       break
    //   }
    // }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.userInfo = util.localGet('userInfo')
      this.name = this.$route.name
      switch (this.name) {
        case 'index':
          console.log('indexinit')
          break
        case 'practise':
          this._getMyKnowledgePointList( {userId: this.userInfo.id} ) // 知识点列表
          break
        case 'knowledgeStrong':
          this._getMyKnowledgePointList( {userId: this.userInfo.id} ) // 知识点列表
          break
        case 'questionBank':
          this._getMyQuestionBankList()
          break
        case 'simulationTest':
          this._getMyExamPaperList()
          break
        case 'errorCollection':
          this._getKnowledgePointErrorsTop10()
          // this.$refs.errorChild.init()
          break
        case 'myExam':
          this._getMyExamPaper()
          break
      }
    },
    selectMenu(name) {
      this.$router.push({
        name: name
      })
      this.name = name
      switch (name) {
        case 'index':
          console.log('indexclick')
          break
        case 'knowledgeStrong':
          this._getMyKnowledgePointList( {userId: this.userInfo.id} )
          break
        case 'questionBank':
          this._getMyQuestionBankList()
          break
        case 'simulationTest':
          this._getMyExamPaperList()
          break
        case 'errorCollection':
          this._getKnowledgePointErrorsTop10()
          if(this.$refs.errorChild){
              this.$refs.errorChild.init()
          }
          break
        case 'myExam':
          this._getMyExamPaper()
          break
      }
    },
    handleClickUserDropdown(name) {
      if (name === 'ownSpace') {
        this.$util.openNewPage(this, 'ownspace_index')
        this.$router.push({
          name: 'ownspace_index'
        })
      } else if (name === 'ownSpaceOld') {
        this.$util.openNewPage(this, 'ownspace_old')
        this.$router.push({
          name: 'ownspace_old'
        })
      } else if (name === 'changePass') {
        this.$util.openNewPage(this, 'change_pass')
        this.$router.push({
          name: 'change_pass'
        })
      } else if (name === 'loginout') {
        // 退出登录
        // this.$store.commit('logout', this)
        // this.$store.commit('clearOpenedSubmenu')
        // this.$util.localRem('userInfo')
        // this.$router.push({name:'knowledgeStrong'})
        // 强制刷新页面 重新加载router
        // location.reload()
        window.opener = null;
        window.open('','_self');
        window.close();
      }
    },
    toRegitst() {
      this.registModal = true
    },
    // 知识点列表
    async _getMyKnowledgePointList(params) {
      this.loading = true
      // let params = {
      //   userId: this.userInfo.id
      // }
      util.md5Encryption(params)
      const res = await this.postTKRequest('/v1/getMyKnowledgePointList', params, true)
      this.loading = false
      if (res.success && res.result.length) {
        res.result.forEach(item => {
          let rate = Number(item.accuracy) * 100
          item.accuracy = rate.toFixed(2) + '%'
        })
        this.knowledgePointList = res.result
      }
    },
    // 题库列表
    async _getMyQuestionBankList() {
      this.tkLoading = true
      let params = {
        userId: this.userInfo.id
      }
      util.md5Encryption(params)
      const res = await this.postTKRequest('/v1/getMyQuestionBankList', params, true)
      this.tkLoading = false
      if (res.success) {
        this.questionBank = res.result
      }
    },
    // 模拟测验列表
    async _getMyExamPaperList() {
      this.tkLoading = true
      let params = {
        userId: this.userInfo.id
      }
      util.md5Encryption(params)
      const res = await this.postTKRequest('/v1/getMyExamPaperList', params, true)
      this.tkLoading = false
      if (res.success) {
        this.paperList = res.result
      }
    },
    // 错误知识点前十
    async _getKnowledgePointErrorsTop10() {
      let params = {
        userId: this.userInfo.id
      }
      util.md5Encryption(params)
      const res = await this.postTKRequest('/v1/getKnowledgePointErrorsTop10', params, true)
      if (res.success) {
        this.errorTopList = res.result
      }
    },
    //我的考试
    async _getMyExamPaper() {
      let params = {
        userId: this.userInfo.id
      }
      util.md5Encryption(params)
      this.tkLoading = true
      const res = await this.postTKRequest('/v1/getMyExamPaper', params, true)
      this.tkLoading = false
      if (res.success) {
        this.myExamList = res.result
      }
    },
    
    toActivate() {
      this.activateModal = true
    },
    handleModalReset() {
      this.activateModal = false
      this.form = {}
    },
    async handleModalSubmit() {
        console.log('jihuo')
    //   this.$refs.formData.validate(async valid => {
    //     if (valid) {
          this.submitLoading = true
          let params = {
            activationCode: this.form.number.trim(),
            userId: this.userInfo.id,
            userName: this.userInfo.username
          }
          util.md5Encryption(params)
          console.log(params)
          const res = await this.postTKRequest("/v1/activationProductCode", params,true);
          if (res.success) {
              this.$Message.success("激活成功")
              this.handleModalReset()
              location.reload()
          }
          this.submitLoading = false
          // this.getList()
    //     }
    //   })
    },
    parentLoginFn(data) {
      this.registModal = false
      this.loginModal = true
    },
    parentSearch(key){
      this.$router.push({
        name: 'knowledgeStrong'
      })
      let params = {
        userId: this.userInfo.id,
        name: key
      }
      this._getMyKnowledgePointList(params)
    },
    submitLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          const res = await this.postTKRequest('/v1/login',{username: this.loginForm.username.trim(),
            password: this.loginForm.password.trim()},true)
          this.loading = false
          if(res.success){
            this.$Message.success('登录成功')
            this.loginModal = false
            this.$router.push({
              name:'index'
            })
            this.$util.localSet('userInfo',res.result)
            setTimeout(()=>{
              location.reload()
            },500)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import './practise.less';
.jihuo{
  margin-right: 20px;
  animation: shinkle 1s linear infinite;
}
@keyframes shinkle {
  0%{
    // box-shadow: 0px 0px 0px #ffa2009d;
  }
  100%{
    box-shadow: 0px 0px 20px #ffa20081;
  }
}
.jihuo:hover{
  border-color: #ffa200;
  color: #ffa200;
  box-shadow: 0px 0px 16px #ffa200cc;
}
.regit-modal, .login-modal, .activate-modal {
  /deep/ .ivu-modal-footer {
    display: none;
  }
  /deep/ .ivu-modal-content {
    background-color: #f3f3f3;
  }
  /deep/ .ivu-modal-body {
    padding: 50px 30px 20px;
  }
  .tit{
    font-size:16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  /deep/ .ivu-btn{
    width: 100%;
    background-color: #ffa200;
    border: none;
    color: #fff;
  }
}
.login-modal {
  position: relative;
  /deep/ .ivu-modal-content {
    background-color: #f3f3f3;
  }

  /deep/ .ivu-modal-body {
    border-radius: 10px;
    padding: 20px 40px;
  }
  /deep/ .ivu-tabs-nav-container {
    line-height: 2;
    font-size: 17px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    zoom: 1;
    .ivu-tabs-nav .ivu-tabs-tab-active{
      color: #ffa200;
      font-size: 16px;
    }
    .ivu-tabs-ink-bar{
      background-color: #ffa200;
    }
  }
  .form {
    padding-top: 1vh;
    input {
      border: 1px solid red;
    }
    /deep/ .ivu-input-suffix i{
      font-size: 24px;
    }
  }
  .forget-pass {
    font-size: 0.14rem;
  }
  .login-btn {
    width: 100%;
    background-color: #ffa200;
    border-color: #ffa200;
  }
  .login-btn {
    margin-bottom: 2vh;
  }
  .forget {
    margin: 0.1rem 0 0.1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/practise.vue